import moment from 'moment';
import { convertMomentToDatePickerTime } from 'helpers/timeFormat';

const CLEAR_SEARCH_FORM = 'zen/BotIntelligence/SearchFilters/CLEAR_SEARCH_FORM';
const EDIT_QUERY = 'zen/BotIntelligence/SearchFilters/EDIT_QUERY';
const SELECT_PROFILE_IDS = 'zen/BotIntelligence/SearchFilters/SELECT_PROFILE_IDS';
const SELECT_SEARCH_BY = 'zen/BotIntelligence/SearchFilters/SELECT_SEARCH_BY';
const PICK_DATE_RANGE = 'zen/BotIntelligence/SearchFilters/PICK_DATE_RANGE';
const TOGGLE_SEARCH_SECTION = 'zen/BotIntelligence/SearchFilters/TOGGLE_SEARCH_SECTION';
const SET_QUERY_PARAMS = 'zen/BotIntelligence/SearchFilters/SET_QUERY_PARAMS';
const SELECT_SMART_FILTER_ID = 'zen/BotIntelligence/SearchFilters/SELECT_SMART_FILTER_ID';
const FETCH_SMART_FILTER = 'zen/BotIntelligence/SearchFilters/FETCH_SMART_FILTER';
const FETCH_SMART_FILTER_SUCCEEDED = 'zen/BotIntelligence/SearchFilters/FETCH_SMART_FILTER_SUCCEEDED';
const FETCH_SMART_FILTER_FAILED = 'zen/BotIntelligence/SearchFilters/FETCH_SMART_FILTER_FAILED';

const initialState = {
  isOpen: true,
  profileIds: [],
  query: '',
  searchBy: 'profiles',
  selectedSmartFilterId: '',
  selectedSmartFilterSummary: null,
  isLoadingSmartFilter: false,
  // last 30 days using DateRangePicker's string format
  startDate: convertMomentToDatePickerTime(moment().subtract(29, 'day').startOf('day')),
  endDate: 'now'
};

// eslint-disable-next-line complexity
const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case CLEAR_SEARCH_FORM: {
      return initialState;
    }
    case SET_QUERY_PARAMS: {
      return {...state, ...payload };
    }
    case EDIT_QUERY: {
      return { ...state, query: payload };
    }
    case PICK_DATE_RANGE: {
      const { endDate, startDate } = payload;
      return { ...state, startDate, endDate };
    }
    case SELECT_PROFILE_IDS: {
      return { ...state, profileIds: payload };
    }
    case SELECT_SEARCH_BY: {
      return { ...state, searchBy: payload };
    }
    case TOGGLE_SEARCH_SECTION: {
      return { ...state, isOpen: !state.isOpen };
    }
    case SELECT_SMART_FILTER_ID: {
      return { ...state, selectedSmartFilterId: payload, selectedSmartFilterSummary: null };
    }
    case FETCH_SMART_FILTER: {
      return { ...state, selectedSmartFilterSummary: null, isLoadingSmartFilter: true };
    }
    case FETCH_SMART_FILTER_SUCCEEDED: {
      const { smartFilter } = payload;
      return { ...state, selectedSmartFilterSummary: smartFilter, isLoadingSmartFilter: false };
    }
    case FETCH_SMART_FILTER_FAILED: {
      return { ...state, selectedSmartFilterSummary: null, isLoadingSmartFilter: false };
    }
    default:
      return state;
  }
};

const clearSearchForm = () => {
  return { type: CLEAR_SEARCH_FORM };
};

const setQueryParams = (payload) => {
  return { type: SET_QUERY_PARAMS, payload };
};

const editQuery = (event) => {
  return { type: EDIT_QUERY, payload: event.target.value };
};

const pickDateRange = (payload) => {
  return { type: PICK_DATE_RANGE, payload };
};

const selectProfiles = (payload) => {
  return { type: SELECT_PROFILE_IDS, payload };
};

const selectSmartFilterId = (payload) => {
  return { type: SELECT_SMART_FILTER_ID, payload };
};

const selectSearchByOption = (event) => {
  return { type: SELECT_SEARCH_BY, payload: event.target.value };
};

const toggleSearchSectionVisibility = () => {
  return { type: TOGGLE_SEARCH_SECTION };
};

const fetchSmartFilter = (payload) => {
  return { type: FETCH_SMART_FILTER, payload };
};

const fetchSmartFilterSucceeded = (payload) => {
  return { type: FETCH_SMART_FILTER_SUCCEEDED, payload };
};

const fetchSmartFilterFailed = (payload) => {
  return { type: FETCH_SMART_FILTER_FAILED, payload };
};


export default reducer;
export {
  // Actions
  CLEAR_SEARCH_FORM,
  EDIT_QUERY,
  PICK_DATE_RANGE,
  SELECT_PROFILE_IDS,
  SELECT_SEARCH_BY,
  TOGGLE_SEARCH_SECTION,
  SELECT_SMART_FILTER_ID,
  FETCH_SMART_FILTER,
  FETCH_SMART_FILTER_SUCCEEDED,
  FETCH_SMART_FILTER_FAILED,
  SET_QUERY_PARAMS,
  // Action Creators
  clearSearchForm,
  editQuery,
  pickDateRange,
  selectProfiles,
  selectSmartFilterId,
  selectSearchByOption,
  toggleSearchSectionVisibility,
  setQueryParams,
  fetchSmartFilter,
  fetchSmartFilterSucceeded,
  fetchSmartFilterFailed
};
